import React from "react";
import { Box } from "@mui/material";
import { IDP_PROVIDER } from "./idpProviders";

function IconFrame({ children }) {
  return (
    <Box
      component="span"
      aria-hidden="true"
      sx={{
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        width: 22,
        height: 22,
        flexShrink: 0,
      }}
    >
      {children}
    </Box>
  );
}

function MicrosoftIcon() {
  return (
    <IconFrame>
      <svg width="22" height="22" viewBox="0 0 22 22" aria-hidden="true">
        <rect x="1" y="1" width="9" height="9" fill="#F25022" />
        <rect x="12" y="1" width="9" height="9" fill="#7FBA00" />
        <rect x="1" y="12" width="9" height="9" fill="#00A4EF" />
        <rect x="12" y="12" width="9" height="9" fill="#FFB900" />
      </svg>
    </IconFrame>
  );
}

function GoogleIcon() {
  return (
    <IconFrame>
      <svg width="22" height="22" viewBox="0 0 22 22" aria-hidden="true">
        <path
          d="M20.2 11.2c0-.7-.1-1.4-.2-2H11v3.8h5.2c-.2 1.2-1 2.2-2.1 2.9v2.4h3.4c2-1.8 3.1-4.5 3.1-7.1z"
          fill="#4285F4"
        />
        <path
          d="M11 21c2.8 0 5.2-.9 6.9-2.5l-3.4-2.4c-.9.6-2.1 1-3.5 1-2.7 0-5-1.8-5.8-4.3H1.7v2.5C3.4 18.7 6.9 21 11 21z"
          fill="#34A853"
        />
        <path
          d="M5.2 12.8c-.2-.6-.3-1.2-.3-1.8s.1-1.2.3-1.8V6.7H1.7C1 8.1.6 9.5.6 11s.4 2.9 1.1 4.3l3.5-2.5z"
          fill="#FBBC05"
        />
        <path
          d="M11 4.8c1.5 0 2.8.5 3.9 1.5l2.9-2.9C16.2 1.8 13.8 1 11 1 6.9 1 3.4 3.3 1.7 6.7l3.5 2.5C6 7.1 8.3 4.8 11 4.8z"
          fill="#EA4335"
        />
      </svg>
    </IconFrame>
  );
}

function OktaIcon() {
  return (
    <IconFrame>
      <svg width="22" height="22" viewBox="0 0 22 22" aria-hidden="true">
        <circle cx="11" cy="11" r="10" fill="#007DC1" />
        <circle cx="11" cy="11" r="4.5" fill="#FFFFFF" />
      </svg>
    </IconFrame>
  );
}

function PingIcon() {
  return (
    <IconFrame>
      <svg width="22" height="22" viewBox="0 0 22 22" aria-hidden="true">
        <circle cx="11" cy="11" r="10" fill="#E30613" />
        <path d="M8 7h2.5v8H8V7zm3.5 0H14v8h-2.5V7z" fill="#FFFFFF" />
      </svg>
    </IconFrame>
  );
}

function KeycloakIcon() {
  return (
    <IconFrame>
      <svg width="22" height="22" viewBox="0 0 22 22" aria-hidden="true">
        <rect x="2" y="2" width="18" height="18" rx="4" fill="#4D4D4D" />
        <path
          d="M7 15l4-8 4 8H7z"
          fill="none"
          stroke="#00B2A9"
          strokeWidth="1.6"
          strokeLinejoin="round"
        />
      </svg>
    </IconFrame>
  );
}

function Auth0Icon() {
  return (
    <IconFrame>
      <svg width="22" height="22" viewBox="0 0 22 22" aria-hidden="true">
        <circle cx="11" cy="11" r="10" fill="#EB5424" />
        <path d="M11 6l5 9H6l5-9z" fill="#FFFFFF" />
      </svg>
    </IconFrame>
  );
}

function OneLoginIcon() {
  return (
    <IconFrame>
      <svg width="22" height="22" viewBox="0 0 22 22" aria-hidden="true">
        <rect x="2" y="2" width="18" height="18" rx="4" fill="#1C1F2A" />
        <path d="M7 7h8v2H7V7zm0 4h8v2H7v-2zm0 4h5v2H7v-2z" fill="#FFFFFF" />
      </svg>
    </IconFrame>
  );
}

function JumpCloudIcon() {
  return (
    <IconFrame>
      <svg width="22" height="22" viewBox="0 0 22 22" aria-hidden="true">
        <circle cx="11" cy="11" r="10" fill="#2C6B4F" />
        <path d="M7 14l4-7 4 7H7z" fill="#FFFFFF" />
      </svg>
    </IconFrame>
  );
}

function ForgeRockIcon() {
  return (
    <IconFrame>
      <svg width="22" height="22" viewBox="0 0 22 22" aria-hidden="true">
        <rect x="2" y="2" width="18" height="18" rx="4" fill="#E57200" />
        <path
          d="M7 8h8v1.5H7V8zm0 3h8v1.5H7V11zm0 3h5v1.5H7V14z"
          fill="#FFFFFF"
        />
      </svg>
    </IconFrame>
  );
}

function IbmVerifyIcon() {
  return (
    <IconFrame>
      <svg width="22" height="22" viewBox="0 0 22 22" aria-hidden="true">
        <rect x="2" y="2" width="18" height="18" rx="2" fill="#0F62FE" />
        <text
          x="11"
          y="14"
          textAnchor="middle"
          fontSize="8"
          fill="#FFFFFF"
          fontFamily="Arial, sans-serif"
        >
          IBM
        </text>
      </svg>
    </IconFrame>
  );
}

function OracleIcon() {
  return (
    <IconFrame>
      <svg width="22" height="22" viewBox="0 0 22 22" aria-hidden="true">
        <rect x="2" y="2" width="18" height="18" rx="2" fill="#C74634" />
        <rect x="5" y="8" width="12" height="6" rx="3" fill="#FFFFFF" />
      </svg>
    </IconFrame>
  );
}

function SalesforceIcon() {
  return (
    <IconFrame>
      <svg width="22" height="22" viewBox="0 0 22 22" aria-hidden="true">
        <circle cx="11" cy="11" r="10" fill="#00A1E0" />
        <path
          d="M8.5 13.5c0-1.4 1.1-2.5 2.5-2.5.5 0 1 .1 1.4.4.4-1.2 1.5-2 2.8-2 1.6 0 2.9 1.3 2.9 2.9 0 .2 0 .4-.1.6-1 .3-1.7 1.2-1.7 2.3 0 1.3 1.1 2.4 2.4 2.4H8.8c-1.2 0-2.2-1-2.2-2.2 0-1 .7-1.9 1.7-2.1z"
          fill="#FFFFFF"
        />
      </svg>
    </IconFrame>
  );
}

function AwsCognitoIcon() {
  return (
    <IconFrame>
      <svg width="22" height="22" viewBox="0 0 22 22" aria-hidden="true">
        <rect x="2" y="2" width="18" height="18" rx="2" fill="#232F3E" />
        <path d="M6 14l3-6 3 4 2-3 2 5H6z" fill="#FF9900" />
      </svg>
    </IconFrame>
  );
}

function DuoIcon() {
  return (
    <IconFrame>
      <svg width="22" height="22" viewBox="0 0 22 22" aria-hidden="true">
        <circle cx="11" cy="11" r="10" fill="#1E1E1E" />
        <circle cx="11" cy="11" r="5" fill="#6CC04A" />
      </svg>
    </IconFrame>
  );
}

function SapIcon() {
  return (
    <IconFrame>
      <svg width="22" height="22" viewBox="0 0 22 22" aria-hidden="true">
        <rect x="2" y="2" width="18" height="18" rx="2" fill="#0A6ED1" />
        <text
          x="11"
          y="14"
          textAnchor="middle"
          fontSize="7"
          fill="#FFFFFF"
          fontFamily="Arial, sans-serif"
        >
          SAP
        </text>
      </svg>
    </IconFrame>
  );
}

function ShieldIcon() {
  return (
    <IconFrame>
      <svg width="22" height="22" viewBox="0 0 22 22" aria-hidden="true">
        <path
          d="M11 2l7 3v5c0 4.5-3 7.8-7 9-4-1.2-7-4.5-7-9V5l7-3z"
          fill="currentColor"
          opacity="0.9"
        />
      </svg>
    </IconFrame>
  );
}

function TenantLogoIcon({ logoUrl, alt }) {
  const decorative = !alt;
  return (
    <Box
      component="img"
      src={logoUrl}
      alt={alt || ""}
      aria-hidden={decorative || undefined}
      sx={{
        width: 22,
        height: 22,
        objectFit: "contain",
        flexShrink: 0,
      }}
    />
  );
}

const ICON_COMPONENTS = {
  [IDP_PROVIDER.MICROSOFT_ENTRA]: MicrosoftIcon,
  [IDP_PROVIDER.GOOGLE]: GoogleIcon,
  [IDP_PROVIDER.OKTA]: OktaIcon,
  [IDP_PROVIDER.PING]: PingIcon,
  [IDP_PROVIDER.KEYCLOAK]: KeycloakIcon,
  [IDP_PROVIDER.AUTH0]: Auth0Icon,
  [IDP_PROVIDER.ONELOGIN]: OneLoginIcon,
  [IDP_PROVIDER.JUMPCLOUD]: JumpCloudIcon,
  [IDP_PROVIDER.FORGEROCK]: ForgeRockIcon,
  [IDP_PROVIDER.IBM_VERIFY]: IbmVerifyIcon,
  [IDP_PROVIDER.ORACLE_IDCS]: OracleIcon,
  [IDP_PROVIDER.SALESFORCE]: SalesforceIcon,
  [IDP_PROVIDER.AWS_COGNITO]: AwsCognitoIcon,
  [IDP_PROVIDER.DUO]: DuoIcon,
  [IDP_PROVIDER.SAP_IAS]: SapIcon,
  shield: ShieldIcon,
};

/**
 * @param {object} props
 * @param {string} props.iconKey
 * @param {string | null} [props.logoUrl]
 * @param {string} [props.alt]
 */
export default function IdpIcon({ iconKey, logoUrl, alt }) {
  if (logoUrl) {
    return <TenantLogoIcon logoUrl={logoUrl} alt={alt} />;
  }

  const IconComponent = ICON_COMPONENTS[iconKey] || ShieldIcon;
  return <IconComponent />;
}
